import React from "react";
import comingSoonImage from "../../../assets/img/comingSoon.jpeg";

interface ProductImageSectionProps {
  product: any;
  handleModalClose: () => void;
}

const ProductImageSection: React.FC<ProductImageSectionProps> = ({
  product,
  handleModalClose,
}) => {
  return (
    <div>
      <div
        className="
          relative w-full h-[200px] overflow-hidden
          md:h-auto
          md:before:content-[''] md:before:block
          md:before:pb-[100%] md:before:pointer-events-none
        "
      >
        <img
          src={product.image || comingSoonImage}
          alt={product.name}
          className="absolute inset-0 w-full h-full object-cover md:rounded-lg"
        />
      </div>

      <div className="flex items-center justify-between mt-5 mx-5 md:mx-0 mb-2">
        <p className="text-2xl font-bold">{product.name}</p>
        <button
          onClick={handleModalClose}
          className="md:absolute top-5 right-5"
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="#3D3D3D"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="3"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default ProductImageSection;
